import { User } from '@/models/User';

export class Support extends User {
  protected $name: string = 'Support';
  protected $endpoint: string = '/users';

  protected filters: object = {
    role: 'support',
  };
}
